import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';

import { PdfReportService } from '../../../service/pdf-report/pdf-report.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { AccountBookService } from '../../../service/account-book/account-book.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';

@Component({
  selector: 'app-root',
  templateUrl: 'wa8002.component.html',
  styleUrls: ['wa8002.component.css']
})

export class Wa8002Component implements AfterViewInit {
  public componentTitle = 'WA8002:月次帳票出力';

  public owners: any;
  public bookyearmonths: any;

  public ownerId: number;
  public bookyearmonthTx: string;

  public reportCd: string;
  public excelFl = 0;

  public reporttrnId: number;
  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  private reportOpened = false;
  private reportTry = 0;

  public url = '#';

  // todo should get from server
  reports = [
    { reportCd: 'RA8001', reportTx: '保管料荷役料明細書' },
    { reportCd: 'RA8002', reportTx: '諸掛明細書' },
    { reportCd: 'RA8003', reportTx: '運送料明細書' },
    { reportCd: 'RA8004', reportTx: '請求書（鑑）サマリ版' },
    { reportCd: 'RA8005', reportTx: '請求書（鑑）明細版' },
    { reportCd: 'RA8011', reportTx: '受寄物月間入出庫および月末保管残高報告書' },
    { reportCd: 'RA8012', reportTx: '受寄物入出庫高及び保管残高報告書' },
    { reportCd: 'RA8021', reportTx: '全社寄託金額一覧表' },
    { reportCd: 'RA8022', reportTx: '特約倉庫貨物火災保険在庫高通知書' },
  ];

  constructor(
    private router: Router,
    private pdfReportService: PdfReportService,
    private ownerService: OwnerService,
    private accountBookService: AccountBookService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ownerChange(event) {
    this.accountBookService
      .getBookYearMonth(this.ownerId)
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        console.log(JSON.stringify(outputJson.bookyearmonths));
        this.bookyearmonths = outputJson.bookyearmonths;
      })
      .catch(error => {
        this.dialogsService
          .info('エラー', this.commonService.getErrorMessage(error))
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.ownerService
    .get()
    .then(outputJson => {
      console.log(JSON.stringify(outputJson));
      this.owners = outputJson.owners;
    })
    .catch(error => {
      this.dialogsService
        .info('エラー', this.commonService.getErrorMessage(error));
    });
  }

  onSubmit() {
    // Change the flag of working to true in order to disable the submit button
    this.working = true;
    if (this.ownerId === undefined) {
      this.dialogsService
        .info('エラー', '荷主を選択してください。');
      this.working = false;
      return;
    }
    if (this.bookyearmonthTx === undefined) {
      this.dialogsService
        .info('エラー', '計上年月を選択してください。');
      this.working = false;
      return;
    }
    if (this.reportCd === undefined) {
      this.dialogsService
        .info('エラー', '帳票を選択してください。');
      this.working = false;
      return;
    }
    // Reset the flag to indicate that the report has not been opened yet
    this.reportOpened = false;
    // Reset the limit counter
    this.reportTry = 0;
    // Submit the request to generate the report
    this.pdfReportService
      .post(
      this.ownerId,
      this.bookyearmonthTx,
      this.reportCd,
      this.excelFl,
      'WA8002',
      )
      .then(outputJson => {
        this.reporttrnId = outputJson.reporttrnId;
        this.working = true;
        this.waitResult();
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.dialogsService
          .info('エラー', this.commonService.getErrorMessage(error))
      });
  }

  waitResult() {
    const obs = Observable.interval(1000)
      .subscribe(() => {
        // Verify that we have not tried more than 10 times
        if (this.reportTry <= 10) {
          // Add a new try to the counter
          this.reportTry++;
          // Call the PDF report service
          this.pdfReportService.get(this.reporttrnId)
            .then(outputJson => {
              // seems we can get the report path correctly
              // If the createdFl is 0 the report has not finished so we retry again.
              // If the createdFl is 1 we get the report name and open a new window to show the PDF file.
              if (outputJson.reports[0].createdFl === 1) {
                // Cancel the Observable when success
                obs.unsubscribe();
                // Change the working flag to false in order to enable the submit button
                this.working = false;
                const url = environment.bucketUrl + '/report/' + outputJson.reports[0].reportpathTx;
                // We open a new tab to display the PDF.
                // If preferred we could get the PDF data and send the blob to the new tab instead.
                this.openReport(url);
              }
              if (outputJson.reports[0].createdFl === -1) {
                // Cancel the Observable when success
                obs.unsubscribe();
                this.working = false;
                this.dialogsService
                  .info('エラー', '対象データがないため帳票が作成できませんでした。');
              }
            })
            .catch(error => {
              // Cancel the Observable in case of error
              obs.unsubscribe();
              // Change the working flag to false in order to enable the submit button
              this.working = false;
              console.log(this.commonService.getErrorMessage(error));
              this.dialogsService
                .info('エラー', this.commonService.getErrorMessage(error));
            });
        } else {
          // Cancel the Observable if the number of tries maxed out
          obs.unsubscribe();
          // Change the working flag to false in order to enable the submit button
          this.working = false;
          this.dialogsService
            .info('エラー', '帳票を取得できませんでした（タイムアウト）。再発する場合は管理者へ連絡してください。');
        }
      })
  }

  // Open the newly generated report on a different tab/window
  openReport(url) {
    // Verify that the report has not been opened already in cases where the network response is slow
    // and we get multiple responses at the same time.
    if (this.reportOpened === false) {
      this.url = url;
      const popup_window = window.open(url);
      try {
        popup_window.focus();
      } catch (e) {
        this.dialogsService
          .customConfirm('エラー', 'ポップアップが許可されていません。PDFを開いて良い場合は、「PDFを開く」ボタンを押してください。', url, 'PDFを開く');
      }
      // Change the flag to indicate that the report was already opened
      this.reportOpened = true;
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa8Billing/wa8002/wa8002.component.ts